import React from 'react';
import styled from 'styled-components';
import { Select } from '../../../components/Select/Select';
import { COLORS, device } from '../../../constants';
import { Title } from '../../../components/Title/Title';
import { FONTS } from '../../../constants';
import { Text } from '../../../components';
import { useTranslation } from 'react-i18next';
import { usePortfolioFilters } from '../../../services/portfolio/usePortfolioFilters';
import { Stack, TopProject } from '../../../types/globalTypes';
import { PortfolioList } from '../partials/PortfolioList';
import { FilterSectionItem } from '../../../components/Filter/FilterSectionItem';
import { FILTER_LIST_HEIGHT } from '../../../constants/filters';

interface PortfolioFiltersProps {
  stacks: Stack;
  projects: TopProject[];
}

export const PortfolioFilters = ({
  stacks,
  projects,
}: PortfolioFiltersProps) => {
  const {
    platforms,
    technologies,
    regions,
    domains,
    selectedRegions,
    selectedPlatforms,
    selectedTechnologies,
    selectedDomains,
    filteredProjects,
    handlePlatformChange,
    handleTechnologyChange,
    handleRegionChange,
    handleDomainChange,
  } = usePortfolioFilters(stacks, projects);
  const { t } = useTranslation();

  return (
    <>
      <FiltersContainer>
        <FiltersSection>
          <Title
            title={t('screen.portfolio.filters.filter')}
            fontFamily={FONTS.TITLE}
            size={36}
            lineHeight={46}
            color={COLORS.SECTION_TITLE}
            isAnimated={true}
          />
          <FilterSectionRow>
            <FilterSectionItem
              title={t('screen.portfolio.filters.platform')}
              optionList={platforms}
              onChange={handlePlatformChange}
              selectedOptions={selectedPlatforms}
              isMultiple={true}
            />
            <FilterSectionItem
              title={t('screen.portfolio.filters.technology')}
              optionList={technologies}
              isMultiple={true}
              onChange={handleTechnologyChange}
              selectedOptions={selectedTechnologies}
            />
            <FilterSectionItem
              title={t('screen.portfolio.filters.domain')}
              optionList={domains}
              isMultiple={true}
              onChange={handleDomainChange}
              selectedOptions={selectedDomains}
              searchEnabled
              listMaxHeight={FILTER_LIST_HEIGHT}
            />
            <FilterSectionItem
              title={t('screen.portfolio.filters.region')}
              isMultiple={true}
              onChange={handleRegionChange}
              selectedOptions={selectedRegions}
              optionList={regions}
              searchEnabled
              listMaxHeight={FILTER_LIST_HEIGHT}
            />
          </FilterSectionRow>
        </FiltersSection>
      </FiltersContainer>
      <PortfolioList projects={filteredProjects} />
    </>
  );
};

const FiltersContainer = styled.div`
  margin-bottom: 40px;
`;

const FiltersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FilterSectionRow = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
  flex-wrap: wrap;
  gap: 40px 70px;
  width: 100%;

  @media screen and (${device.sm}) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
